import React, { useMemo, useEffect } from "react";
import { useQuery, useQueries } from 'react-query'
import { useViewport } from 'components/general/useViewPort'
import { getResultsRSC, getUnits } from "data/Querys"
import { getPhaseRSC, getLongPhaseRSC } from 'helpers/rsc'
import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
import Status from "components/presentation/Status";
import NotAvailable from 'components/common/NotAvailable';
import Label from "components/general/Label"
import Loader from 'components/general/Loader';
import { isStartListStatus, isLiveStatus } from "helpers/status";
import ProgressionRule from "components/common/ProgressionRule";
import { TableExpanded } from 'components/sports/csl/events/extreme/TableExpanded';
import {
  TableColumnsELIMStartList as ColumnsStartList
  , TableColumnsELIMLive as ColumnsLive
  , TableColumnsELIMFinish as ColumnsFinish
} from 'components/sports/csl/events/extreme/Columns';
import PhotoFinish from "components/general/PhotoFinish";
import Stack from 'react-bootstrap/Stack';
import PageHeader from "components/common/PageHeader";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const getConfiguration = (data, breakPoint) => {
  const columnsAdded = [];
  const resultStatus = data?.results?.status?.code;
  const scheduleStatus = data?.results?.schedule?.status?.code;

  let configuration = {
    caption: null,
    columns: [],
    //subComponent: null,
    hiddenColumns: [],
    sortBy: [],
    filters: {
      ei_type: ['NONE'],
      ei_code: ['NONE']
    },
    configs: {
      isStartList: isStartListStatus(resultStatus),
      columnsAdded: columnsAdded,
      previousCurrent: false,
    }
  };

  configuration.caption = <CaptionTable
    leftCol={<h3>{data && data?.results?.eventUnit?.shortDescription}</h3>}
    rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />}
  />

  configuration.sortBy = isStartListStatus(resultStatus)
    ? [{ id: 'Bib', desc: false }]
    : [{ id: 'Rank', desc: false }]


  configuration.columns = isStartListStatus(resultStatus)
    ? ColumnsStartList()
    : isLiveStatus(resultStatus)
      ? ColumnsLive()
      : ColumnsFinish()

  return configuration;
};

function CslExtremeElimination() {
  const { breakPoint } = useViewport();
  const { mirs_competition, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()
  let _phase = getPhaseRSC(mirs_rsc);
  let _longPhase = getLongPhaseRSC(mirs_rsc);
  let queryArray = [];

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  //DATA
  const { data: unitsData, isError: unitsError, isLoading: unitsLoading } = useQuery(
    {
      queryKey: ['unitsPhase', mirs_competition, mirs_language, _phase, (_phase.indexOf('FNL') > -1) ? 'Y' : 'S'],
      queryFn: getUnits,
      //refetchInterval: 30000,
      staleTime: Infinity,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
    }
  );


  unitsData?.phase?.units?.forEach((unit) => {
    queryArray.push({
      queryKey: ['resultsData', mirs_competition, unit.code, mirs_language, _longPhase],
      queryFn: getResultsRSC,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
    })
  });

  const results = useQueries(queryArray);
  const isLoading = unitsLoading || results.some(result => result.isLoading)
  const isError = unitsError || results.some(result => result.isError)

  if (isError) { return <NotAvailable />; }
  if (isLoading) { return <Loader />; }

  return (
    <>
      <PageHeader title={unitsData?.phase?.description} />
      {
        results.map((res, index) => {
          return (
            <>
              {(index === 0) &&
                <ProgressionRule
                  key="progress-component"
                  data={res.data?.config}
                  filter={{ type: ['QUALIFICATION'], code: ['QUAL_RULE'] }}
                />
              }
              <ResultPage key={`csl-result-${index}`} data={res?.data} breakPoint={breakPoint} />
            </>
          )
        })
      }
    </>
  );
}

export default CslExtremeElimination;

function ResultPage({ data, breakPoint }) {
  const rsc = data?.results?.eventUnitCode;
  const resultStatus = data?.results?.status?.code;

  const configEvent = useMemo(() => getConfiguration(data, breakPoint), [resultStatus, breakPoint]);

  // Create a function that will render our row sub components
  const renderRowSubComponent = React.useCallback(({ row }) => (
    <LoaderSubComponent component={
      <TableExpanded row={row?.original} config={data?.config} resultStatus={resultStatus} />
    }
    />
    // eslint-disable-next-line
  ), [resultStatus, breakPoint]);

  let hiddenColumns = []

  return (
    <>
      {data?.images
        && <Stack direction="horizontal">
          <div className="ms-auto"></div>
          <strong><Label data='LabelPhotoFinish' />:&nbsp;</strong>
          <PhotoFinish data={data?.images} />
        </Stack>
      }
      {data?.results?.items
        && < MirsTable
          //Dato to show by row
          data={data.results.items}
          //Columnas a visualizar 
          columns={configEvent.columns}
          //subcomponente a renderizar, extended
          renderRowSubComponent={renderRowSubComponent}
          //Key by row necesary in order to no paint innecesary
          keyRow='participant-code'
          //Component caption
          caption={configEvent.caption}
          //Columns to hidde 
          hiddenColumns={hiddenColumns}
          //When show tble is sorted by 
          initialSortBy={configEvent.sortBy}
          //classCaption={isLiveStatus(resultStatus) ? 'currentIndicator' : ''}
          id={`mirs-table-result-${rsc}`}
        />
      }
    </>
  );
}

